// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3fF8V","content":"LoadingAlert_content__2Fzos"};